var UserAnnouncementStatusTypeEnum;
(function (UserAnnouncementStatusTypeEnum) {
    UserAnnouncementStatusTypeEnum["UNREAD"] = "Unread";
    UserAnnouncementStatusTypeEnum["READ"] = "Read";
})(UserAnnouncementStatusTypeEnum || (UserAnnouncementStatusTypeEnum = {}));
export default UserAnnouncementStatusTypeEnum;
